const modal = {
    events: {},
    itemsN:0,

    closeAll: () => {
      $('.modal').modal('hide');
    },

    close: (id=false) => {
        if (id !== false) {
            $(`#modal${id}`).modal('hide');
        } else {
            $('#modal').modal('hide');
        }
    },
    add(title, message, template=false, params={}, events={}){
        modal.prepare(title, message, template, params, events);
        const id = this.itemsN;
        const html = $("#modal").html();
        $('body').append(`<div class="modal fade" id='modal${id}'  tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">${html}</div>`);
        $(`#modal${id}`).modal('show');

        const myModalEl = document.getElementById(`modal${id}`);
        myModalEl.addEventListener('hidden.bs.modal', function (event) {
            $(`#modal${id}`).remove();
        })

        this.itemsN++;
        return id;
    },

    prepare(title, message, template=false, params={}, events={}) {

        if (template) {
            $('#modal .modal-body').html( $('.modal-assets '+ template).html() );
            $('#modal .modal-footer').removeClass('d-flex');
            $('#modal .modal-footer').addClass('d-none');
        } else {
            $('#modal .modal-body').html('<span class="message"></span>');
            $('#modal .modal-footer').addClass('d-flex');
            $('#modal .modal-footer').removeClass('d-none');
        }

        if (message)
            $('#modal .modal-body .message').text(__(message));

        $('#modal .modal-title').text(__(title));

        for(const id in params) {
            const value = params[id];
            if (isNaN(value))
                $('#modal '+id).html(__(String(value)));
            else
                $('#modal '+id).html(value);
        }

        for(const id in events) {
            const event = events[id];
            $(document).off('click', '#modal '+id);
            $(document).on('click', '#modal '+id, event);
        }

    },
    info: (title, message, template=false, params={}, events={}) => {
         modal.prepare(title, message, template, params, events);


         if ($('#modal').length)
             $('#modal').modal('show');
    },

}

export default modal;
